import apiBaseUrl from "./apiBaseUrl";

console.log("Hostname actual:", window.location.hostname);
console.log("Comparando con:", '181.57.163.54');

const baseServer = apiBaseUrl();

console.log("Base Server seleccionado:", baseServer);

export default {
    servicioURL: baseServer,
    servicioApi: baseServer + '/api',
}
